<template>
    <ModalCancel :show="showModal" @close="toggleShowModal"/>
    <ModalActivate :show="showActivate" @close="toggleShowModalActivate"/>

    <section class="mb-5">
        <div class="max-w-6xl mx-auto px-4 pb-0">
            <div class="box px-5 sm:px-10 pt-10 w-full">
                <div class=" mb-5 pb-3">
                    <h4 class="mb-3 text-xl md:text-2xl text-green-400 font-bold">
                        {{dashboardTranslate[language].subscription.settings.title}}
                    </h4>
                    <p class="text-gray-800 text-sm">{{dashboardTranslate[language].subscription.settings.subtitle}}</p>
                    <div class="flex flex-col lg:flex-row justify-evenly items-left" v-if="subscription">
                        <div class="font-semibold w-full lg:w-auto text-green-400 text-lg mt-5 mb-3 lg:my-5" >
                            <button @click="toggleShowModal" class="hover:text-green-200 font-semibold" v-if="subscription.subscription.state == 'active'">
                                {{dashboardTranslate[language].subscription.settings.cancel}}
                            </button>
                            <button @click="toggleShowModalActivate" class="hover:text-green-200 font-semibold" v-if="subscription.subscription.state == 'canceled'">
                                {{dashboardTranslate[language].subscription.settings.activate}}
                            </button>
                        </div>
                        <div class="font-semibold w-full lg:w-auto text-green-400 text-lg my-3 lg:my-5   " v-if="subscription.subscription.state == 'active' && hasDowngrade == false">
                            <div v-if="!hasDowngrade">
                                <a  class="hover:text-green-200 cursor-pointer"  @click.prevent="goToLink('DashboardSubCambiar', { userType: subscription.subscription.subscriptionType , label: 'click_change_membership_type',  paymentTerm : subscription.subscription.currentAmount.paymentTerm})">
                                    {{dashboardTranslate[language].subscription.settings.change}}
                                </a>
                            </div>
                        </div>
                        <div class="font-semibold w-full lg:w-auto text-green-400 text-lg my-3 lg:mt-5 " v-if="subscription.subscription.subscriptionType != 'Single' && isExpiredToAddCompanions == false">
                            <div v-if="subscription.subscription.state == 'active'  ">
                                <a class="hover:text-green-200 cursor-pointer" 
                                    @click.prevent="goToLink('DashboardSubAcompanantes', { userType: subscription.subscription.subscriptionType , label: 'click_modify_companions',  paymentTerm : subscription.subscription.currentAmount.paymentTerm})">
                                    {{dashboardTranslate[language].subscription.settings.modify}}
                                </a>
                            </div>
                            <div v-else>
                                <a class="hover:text-green-200 cursor-pointer" 
                                    @click.prevent="goToLink('DashboardSubAcompanantes', { userType: subscription.subscription.subscriptionType , label: 'click_modify_companions',  paymentTerm : subscription.subscription.currentAmount.paymentTerm})" v-if="!isExpiredToAddCompanions">
                                    {{dashboardTranslate[language].subscription.settings.modify}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center p-10">
            <div>{{dashboardTranslate[language].information.text }} </div>
            <div><a :href="`mailto:${dashboardTranslate[language].information.email}`" class="text-green-400 font-semibold">{{dashboardTranslate[language].information.email }} </a></div>
        </div>
    </section>
</template>

<script>
import ModalCancel from "@/components/modals/ModalCancel.vue"
import ModalActivate from "@/components/modals/ModalActivate.vue"
import { dashboardTranslate } from '@/translations/Dashboard.js'
import { dataLayerCancelSubscription, dataLayerCancelSubscriptionMoreThanAYear, dataLayerMangeSubSettings} from '@/pixels/datalayer.js'

import { computed, ref } from "@vue/reactivity"
import { useStore } from "vuex"
import { onMounted, watch } from "@vue/runtime-core"
import { useRouter } from "vue-router"

export default({
    name: 'AdjustSusbcrption',
    props: ['showModalActive'],
    components: {
        ModalCancel,
        ModalActivate,
    },
    setup( props ){
        
        const store  = useStore()
        const router = useRouter()
        const showActivate = ref( false )
        const showModal = ref( false )
        const subscription = computed( () =>{
            return store.state.Checkout.data.userSubscription.data
        })
        const isPlansLoading = computed( ()=> {
             return store.state.Plans.loading
        })

        const hasDowngrade = computed(() => {
            const plans =  store.state.Plans.data.plans
            let foundD, foundU, found;
            if( plans ){
                 foundD = plans.find( ({type}) =>  type == 'downgrade'  )
                 foundU = plans.find( ({type}) =>  type == 'upgrade'  )

                found = ( foundD  && foundU ) ? false : ( foundD  && !foundU ) ? true : false
            }

            return isPlansLoading.value ? true : found ?  true : false
        })

        const toggleShowModal = () => {
            showModal.value = !showModal.value

            const create = new Date(subscription.value.subscription.creationDate )
            const today =  new Date()
            const years  =  today.getFullYear() - create.getFullYear()

            if (years > 1 ){
                dataLayerCancelSubscriptionMoreThanAYear()
            } else {
                dataLayerCancelSubscription()
            }

        dataLayerMangeSubSettings( { userType: subscription.value.subscription.subscriptionType , label: 'click_cancel_renovation',  paymentTerm : subscription.value.subscription.currentAmount.paymentTerm})

        }

        const toggleShowModalActivate = () => {
            dataLayerMangeSubSettings( { userType: subscription.value.subscription.subscriptionType , label: 'click_activate_renovation',  paymentTerm : subscription.value.subscription.currentAmount.paymentTerm})
            showActivate.value = !showActivate.value
        }

        const goToLink = ( routeName, params  ) => {

            dataLayerMangeSubSettings( params)
        
            router.push({name: routeName })
        }
        
        const language = computed( ()=> {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })

          const isExpiredToAddCompanions = computed(() => {
             if( subscription.value ){
                let expire = new Date(subscription.value.subscription.creationDate )
                let today =  new Date()
                let yearFromDate = expire.getFullYear();
                let monthFromYear = expire.getMonth();
                let dayFromYear = expire.getDate();
                let newDate = new Date(yearFromDate, monthFromYear  + 3, dayFromYear);
                let now =  today.setHours(0,0,0,0) > newDate.setHours(0,0,0,0)
                return now
             }
        })
        
        
        watch( () => props.showModalActive, (value) => {
            showActivate.value = value
        })

        onMounted( async ()=> {
             if( !subscription.value ){
            let params = { plan: 'vfn' , continue : false} 
            if( Object.keys(store.state.Accounts.data).length == 0 ){
                params.continue  = true
            }
                await store.dispatch('getSubscription', params )
            }
        })
        return { subscription, dashboardTranslate, language, isExpiredToAddCompanions, showActivate, goToLink, showModal, toggleShowModal, toggleShowModalActivate, hasDowngrade}
    }
})
</script>

<style scoped>
    .section-header {
        @apply text-3xl text-green-400 font-semibold md:font-bold;
    }
    .box {
        @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
    }
    
    h5 {
        @apply md:text-sm text-green-400;
        font-size:0.75rem;
    }
</style>